import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

export const getCheckoutTokenInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (!request.url.includes('oauth2')) {
    return next(request);
  }

  const updatedRequest = request.clone({
    headers: request.headers.set(
      'content-type',
      'application/x-www-form-urlencoded'
    ),
  });
  return next(updatedRequest);
};
